import { ReactNode } from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';

import { getEligibilityCheckModule } from '@pass-frontend/features/standalone/data-access';

export function EligibilityCheckModuleLoader({
  children,
}: {
  children: ReactNode;
}) {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <DynamicModuleLoader modules={[getEligibilityCheckModule()]}>
      {children}
    </DynamicModuleLoader>
  );
}

export default EligibilityCheckModuleLoader;
